import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DefaultInternationalIcon from './InternationalIcon';
import Flag from './Flag';

export function createCountryIconComponent({
  flags,
  flagUrl,
  flagComponent: FlagComponent,
  internationalIcon: InternationalIcon,
}) {
  function CountryIcon({
    country,
    label,
    aspectRatio,
    className,
    internationalIcon,
  }) {
    // `aspectRatio` is currently a hack for the default "International" icon
    // to render it as a square when Unicode flag icons are used.
    // So `aspectRatio` property is only used with the default "International" icon.
    const _aspectRatio =
      InternationalIcon === DefaultInternationalIcon ? aspectRatio : undefined;
    const Icon = internationalIcon ? internationalIcon : InternationalIcon;
    return (
      <div
        className={classNames(
          'PhoneInputCountryIcon',
          {
            'PhoneInputCountryIcon--square': _aspectRatio === 1,
            'PhoneInputCountryIcon--border': country,
          },
          className
        )}
      >
        {country ? (
          <FlagComponent
            country={country}
            countryName={label}
            flags={flags}
            flagUrl={flagUrl}
            className="PhoneInputCountryIconImg"
          />
        ) : (
          <Icon
            title={label}
            aspectRatio={_aspectRatio}
            className="PhoneInputCountryIconImg"
          />
        )}
      </div>
    );
  }

  CountryIcon.propTypes = {
    aspectRatio: PropTypes.number,
    className: PropTypes.string,
    country: PropTypes.string,
    internationalIcon: PropTypes.func,
    label: PropTypes.string.isRequired,
  };

  return CountryIcon;
}

export default createCountryIconComponent({
  // Must be equal to `defaultProps.flagUrl`
  flagUrl: 'https://catamphetamine.github.io/country-flag-icons/3x2/{XX}.svg',
  flagComponent: Flag,
  internationalIcon: DefaultInternationalIcon,
});
